import { api } from '@/lib/api'
import { Atendimento } from '@/pages/atendimentos/interfaces/atendimento.interface'
import { useQuery } from '@tanstack/react-query'
import { PaginationInfo } from '@/components/TablePaginator'

interface FiltrosAtendimentos {
  search?: string
  status?: string
  dataInicio?: string
  dataFim?: string
  page?: number
  limit?: number
}

export interface AtendimentosPaginatedResponse {
  data: Atendimento[]
  pagination: PaginationInfo
}

export const useAtendimentos = (filtros?: FiltrosAtendimentos) => {
  return useQuery<AtendimentosPaginatedResponse, Error>({
    queryKey: ['atendimentos', filtros],
    queryFn: async () => {
      try {
        const params = new URLSearchParams()

        if (filtros?.search) params.append('search', filtros.search)
        if (filtros?.status) params.append('status', filtros.status)
        if (filtros?.dataInicio) params.append('dataInicio', filtros.dataInicio)
        if (filtros?.dataFim) params.append('dataFim', filtros.dataFim)
        if (filtros?.page) params.append('page', filtros.page.toString())
        if (filtros?.limit) params.append('limit', filtros.limit.toString())

        const queryString = params.toString()
        const url = queryString
          ? `/api/atendimentos?${queryString}`
          : '/api/atendimentos'

        const response = (await api.get(url)) as {
          result: AtendimentosPaginatedResponse
        }
        return response.result
      } catch (error) {
        console.error('Erro ao carregar atendimentos:', error)
        throw error
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    refetchOnWindowFocus: false
  })
}

export const useAtendimento = (id: number) => {
  return useQuery<Atendimento, Error>({
    queryKey: ['atendimento', id],
    queryFn: async () => {
      try {
        const response = (await api.get(`/api/atendimentos/${id}`)) as {
          result: Atendimento
        }
        return response.result
      } catch (error) {
        console.error('Erro ao carregar atendimento:', error)
        throw error
      }
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000
  })
}
